<template>
  <div class="design-tree">
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose">
      <span>计算的结果为：{{values}}</span>
      <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
     </span>
    </el-dialog>
    <el-tree
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0)"
      ref="tree"
      :data="tree_data"
      :props="props"
      :expand-on-click-node="false"
      :auto-expand-parent="true"
      :highlight-current="true"
      :indent="12"
      node-key="id"
      @current-change="tree_selection_change"
      @node-contextmenu="tree_right_click"
      @node-click="tree_left_click"
    >
      <span
        slot-scope="{ node, data }"
        class="custom-tree-node"
      >
        <span>
          <!-- <i :class="node.icon" /> -->
          <!-- {{ node }} -->
          <img
            :src="data.icon"
            style="width:18px;height:22px;padding-top:5px;"
          >
          {{ data.name }}
        </span>
      </span>
    </el-tree>
    <Menu
      ref="context_menu"
      :duration="1000"
      @itemClick="tree_menuItemClick"
    >
      <MenuItem
        :disabled="!('root,project,folder,server,logicalGroup,deviceGroup,device,onlineChart').includes(selectedNodeType)"
        text="展开"
        iconCls="icon-spread"
      ></MenuItem>
      <MenuItem
        :disabled="!('root,project,folder,server,logicalGroup,deviceGroup,device,onlineChart').includes(selectedNodeType)"
        text="折叠"
        iconCls="icon-fold"
      ></MenuItem>
      <Menu-sep />
      <MenuItem
        :disabled="!('root,project,server,folder,logicalGroup,deviceGroup,device,subDevice,onlineChart').includes(selectedNodeType)"
        text="搜索"
        iconCls="icon-search"
      >
        <div
          align="right"
          style="font-size: 12px"
        >Ctrl+F</div>
      </MenuItem>
      <Menu-sep v-if="!'subDevice'===selectedNodeType" />
      <MenuItem
        v-if="('root').includes(selectedNodeType)"
        text="新建"
        iconCls="icon-new-add"
      >
        <SubMenu
          menu-width="60px"
        >
          <MenuItem
            text="项目组"
            iconCls="icon-project"
          ></MenuItem>
        </SubMenu>
      </MenuItem>
      <MenuItem
        v-if="('project').includes(selectedNodeType)"
        text="新建"
        iconCls="icon-new-add"
      >
        <SubMenu menu-width="60px">
          <MenuItem
            text="项目"
            iconCls="icon-server"
          ></MenuItem>
        </SubMenu>
      </MenuItem>
      <MenuItem
        v-if="('folder').includes(selectedNodeType)"
        text="新建"
        iconCls="icon-new-add"
      >
        <SubMenu menu-width="60px">
          <MenuItem
            text="文件夹"
            iconCls="icon-folder"
          ></MenuItem>
          <MenuItem
            text="对象"
            iconCls="icon-object"
          >
            <SubMenu menu-width="60px">
              <MenuItem
                text="报警接收者-Printer"
                iconCls="icon-printer"
              ></MenuItem>
              <MenuItem
                text="状态变化-系统"
                iconCls="icon-changeState"
              ></MenuItem>
              <MenuItem
                text="曲线图-实时"
                iconCls="icon-onlineChart"
              ></MenuItem>
              <MenuItem
                text="曲线图-趋势记录"
                iconCls="icon-onlineChartLog"
              ></MenuItem>
              <MenuItem
                text="图形化界面"
                iconCls="icon-graphic"
              ></MenuItem>
              <MenuItem
                text="假期计划表"
                iconCls="icon-holidayPlan"
              ></MenuItem>
              <MenuItem
                text="记事本"
                iconCls="icon-noteBook"
              ></MenuItem>
              <MenuItem
                text="对象传输"
                iconCls="icon-objectTransfer"
              ></MenuItem>
              <MenuItem
                text="时间表"
                iconCls="icon-chartTime"
              ></MenuItem>
              <MenuItem
                text="时间事件-对象"
                iconCls="icon-chartTimeEventObj"
              ></MenuItem>
              <MenuItem
                text="时间事件-列表"
                iconCls="icon-chartTimeEventList"
              ></MenuItem>
              <MenuItem
                text="趋势日志-计算"
                iconCls="icon-trendLogCal"
              ></MenuItem>
              <MenuItem
                text="趋势日志-导出"
                iconCls="icon-trendLogOut"
              ></MenuItem>
              <MenuItem
                text="趋势日志"
                iconCls="icon-trendLog"
              ></MenuItem>
              <MenuItem
                text="值-模拟量"
                iconCls="icon-Analog"
              ></MenuItem>
              <MenuItem
                text="值-二进制"
                iconCls="icon-Binary"
              ></MenuItem>
              <MenuItem
                text="值-多态"
                iconCls="icon-Multistate"
              ></MenuItem>
              <MenuItem
                text="值-字符串"
                iconCls="icon-String"
              ></MenuItem>
              <MenuItem
                text="数值计算"
                iconCls="icon-Count"
              ></MenuItem>
              <MenuItem
                text="报警视窗"
                iconCls="icon-alarm-window"
              ></MenuItem>
              <MenuItem
                text="数据接口"
                iconCls="icon-event-window"
              ></MenuItem>
            </SubMenu>
          </MenuItem>
        </SubMenu>
      </MenuItem>
      <MenuItem
        v-if="('server').includes(selectedNodeType)"
        text="新建"
        iconCls="icon-new-add"
      >
        <SubMenu menu-width="60px">
          <MenuItem
            text="场景"
            iconCls="icon-logic-group"
          >
            <SubMenu
              menu-width="60px"
            >
              <MenuItem
                text="空调机组"
                iconCls="icon-graphic"
              ></MenuItem>
              <MenuItem
                text="机房"
                iconCls="icon-graphic"
              ></MenuItem>
              <MenuItem
                text="冷冻站"
                iconCls="icon-graphic"
              ></MenuItem>
              <MenuItem
                text="场景"
                iconCls="icon-graphic"
              ></MenuItem>
              <MenuItem
                text="机房"
                iconCls="icon-graphic"
              ></MenuItem>
              <MenuItem
                text="冷冻站"
                iconCls="icon-graphic"
              ></MenuItem><MenuItem
              text="空调机组"
              iconCls="icon-graphic"
            ></MenuItem>
              <MenuItem
                text="机房"
                iconCls="icon-graphic"
              ></MenuItem>
              <MenuItem
                text="冷冻站"
                iconCls="icon-graphic"
              ></MenuItem>
            </SubMenu>
          </MenuItem>
          <MenuItem
            text="逻辑组"
            iconCls="icon-folder"
          ></MenuItem>
        <!--  <MenuItem
            text="对象"
            iconCls="icon-object"
          >

            <SubMenu menu-width="60px">
              <MenuItem
                text="报警接收者-Printer"
                iconCls="icon-printer"
              ></MenuItem>
              <MenuItem
                text="状态变化-系统"
                iconCls="icon-changeState"
              ></MenuItem>
              <MenuItem
                text="曲线图-实时"
                iconCls="icon-onlineChart"
              ></MenuItem>
              <MenuItem
                text="曲线图-趋势记录"
                iconCls="icon-onlineChartLog"
              ></MenuItem>
              <MenuItem
                text="图形化界面"
                iconCls="icon-graphic"
              ></MenuItem>
              <MenuItem
                text="假期计划表"
                iconCls="icon-holidayPlan"
              ></MenuItem>
              <MenuItem
                text="记事本"
                iconCls="icon-noteBook"
              ></MenuItem>
              <MenuItem
                text="对象传输"
                iconCls="icon-objectTransfer"
              ></MenuItem>
              <MenuItem
                text="时间表"
                iconCls="icon-chartTime"
              ></MenuItem>
              <MenuItem
                text="时间事件-对象"
                iconCls="icon-chartTimeEventObj"
              ></MenuItem>
              <MenuItem
                text="时间事件-列表"
                iconCls="icon-chartTimeEventList"
              ></MenuItem>
              <MenuItem
                text="趋势日志-计算"
                iconCls="icon-trendLogCal"
              ></MenuItem>
              <MenuItem
                text="趋势日志-导出"
                iconCls="icon-trendLogOut"
              ></MenuItem>
              <MenuItem
                text="趋势日志"
                iconCls="icon-trendLog"
              ></MenuItem>
              <MenuItem
                text="值-模拟量"
                iconCls="icon-Analog"
              ></MenuItem>
              <MenuItem
                text="值-二进制"
                iconCls="icon-Binary"
              ></MenuItem>
              <MenuItem
                text="值-多态"
                iconCls="icon-Multistate"
              ></MenuItem>
              <MenuItem
                text="值-字符串"
                iconCls="icon-String"
              ></MenuItem>
              <MenuItem
                text="数值计算"
                iconCls="icon-Count"
              ></MenuItem>
              <MenuItem
                text="报警视窗"
                iconCls="icon-alarm-window"
              ></MenuItem>
              <MenuItem
                text="数据接口"
                iconCls="icon-event-window"
              ></MenuItem>
            </SubMenu>
          </MenuItem>-->
        </SubMenu>
      </MenuItem>
      <MenuItem
        v-if="('logicalGroup').includes(selectedNodeType)"
        text="新建"
        iconCls="icon-new-add"
      >
        <SubMenu menu-width="60px">
          <MenuItem
            text="文件夹"
            iconCls="icon-folder"
          ></MenuItem>
          <MenuItem
            text="设备组"
            iconCls="icon-device-group"
          >
            <SubMenu menu-width="60px">
              <MenuItem
                text="AIM"
                iconCls="icon-folder"
              ></MenuItem>
              <MenuItem
                text="OPC Server"
                iconCls="icon-device"
              ></MenuItem>
              <MenuItem
                text="BACNET"
                iconCls="icon-save"
              ></MenuItem>
            </SubMenu>
          </MenuItem>
          <MenuItem
            text="对象"
            iconCls="icon-object"
          >
            <SubMenu menu-width="60px">
              <MenuItem
                text="报警接收者-Printer"
                iconCls="icon-printer"
              ></MenuItem>
              <MenuItem
                text="状态变化-系统"
                iconCls="icon-changeState"
              ></MenuItem>
              <MenuItem
                text="曲线图-实时"
                iconCls="icon-onlineChart"
              ></MenuItem>
              <MenuItem
                text="曲线图-趋势记录"
                iconCls="icon-onlineChartLog"
              ></MenuItem>
              <MenuItem
                text="图形化界面"
                iconCls="icon-graphic"
              ></MenuItem>
              <MenuItem
                text="假期计划表"
                iconCls="icon-holidayPlan"
              ></MenuItem>
              <MenuItem
                text="记事本"
                iconCls="icon-noteBook"
              ></MenuItem>
              <MenuItem
                text="对象传输"
                iconCls="icon-objectTransfer"
              ></MenuItem>
              <MenuItem
                text="时间表"
                iconCls="icon-chartTime"
              ></MenuItem>
              <MenuItem
                text="时间事件-对象"
                iconCls="icon-chartTimeEventObj"
              ></MenuItem>
              <MenuItem
                text="时间事件-列表"
                iconCls="icon-chartTimeEventList"
              ></MenuItem>
              <MenuItem
                text="趋势日志-计算"
                iconCls="icon-trendLogCal"
              ></MenuItem>
              <MenuItem
                text="趋势日志-导出"
                iconCls="icon-trendLogOut"
              ></MenuItem>
              <MenuItem
                text="趋势日志"
                iconCls="icon-trendLog"
              ></MenuItem>
              <MenuItem
                text="值-模拟量"
                iconCls="icon-Analog"
              ></MenuItem>
              <MenuItem
                text="值-二进制"
                iconCls="icon-Binary"
              ></MenuItem>
              <MenuItem
                text="值-多态"
                iconCls="icon-Multistate"
              ></MenuItem>
              <MenuItem
                text="值-字符串"
                iconCls="icon-String"
              ></MenuItem>
              <MenuItem
                text="数值计算"
                iconCls="icon-Count"
              ></MenuItem>
              <MenuItem
                text="报警视窗"
                iconCls="icon-alarm-window"
              ></MenuItem>
              <MenuItem
                text="数据接口"
                iconCls="icon-event-window"
              ></MenuItem>
            </SubMenu>
          </MenuItem>
        </SubMenu>
      </MenuItem>
      <MenuItem
        v-if="'deviceGroup'===selectedNodeType"
        text="新建"
        iconCls="icon-new-add"
      >
        <SubMenu menu-width="60px">
          <MenuItem
            text="文件夹"
            iconCls="icon-folder"
          ></MenuItem>
          <MenuItem
            text="设备"
            iconCls="icon-device"
          >
            <SubMenu menu-width="60px">
              <MenuItem
                text="ICU"
                iconCls="icon-folder"
              ></MenuItem>
            </SubMenu>
          </MenuItem>
          <MenuItem
            text="对象"
            iconCls="icon-object"
          >
            <SubMenu menu-width="60px">
              <MenuItem
                text="报警接收者-Printer"
                iconCls="icon-printer"
              ></MenuItem>
              <MenuItem
                text="状态变化-系统"
                iconCls="icon-changeState"
              ></MenuItem>
              <MenuItem
                text="曲线图-实时"
                iconCls="icon-onlineChart"
              ></MenuItem>
              <MenuItem
                text="曲线图-趋势记录"
                iconCls="icon-onlineChartLog"
              ></MenuItem>
              <MenuItem
                text="图形化界面"
                iconCls="icon-graphic"
              ></MenuItem>
              <MenuItem
                text="假期计划表"
                iconCls="icon-holidayPlan"
              ></MenuItem>
              <MenuItem
                text="记事本"
                iconCls="icon-noteBook"
              ></MenuItem>
              <MenuItem
                text="对象传输"
                iconCls="icon-objectTransfer"
              ></MenuItem>
              <MenuItem
                text="时间表"
                iconCls="icon-chartTime"
              ></MenuItem>
              <MenuItem
                text="时间事件-对象"
                iconCls="icon-chartTimeEventObj"
              ></MenuItem>
              <MenuItem
                text="时间事件-列表"
                iconCls="icon-chartTimeEventList"
              ></MenuItem>
              <MenuItem
                text="趋势日志-计算"
                iconCls="icon-trendLogCal"
              ></MenuItem>
              <MenuItem
                text="趋势日志-导出"
                iconCls="icon-trendLogOut"
              ></MenuItem>
              <MenuItem
                text="趋势日志"
                iconCls="icon-trendLog"
              ></MenuItem>
              <MenuItem
                text="值-模拟量"
                iconCls="icon-Analog"
              ></MenuItem>
              <MenuItem
                text="值-二进制"
                iconCls="icon-Binary"
              ></MenuItem>
              <MenuItem
                text="值-多态"
                iconCls="icon-Multistate"
              ></MenuItem>
              <MenuItem
                text="值-字符串"
                iconCls="icon-String"
              ></MenuItem>
              <MenuItem
                text="数值计算"
                iconCls="icon-Count"
              ></MenuItem>
              <MenuItem
                text="报警视窗"
                iconCls="icon-alarm-window"
              ></MenuItem>
              <MenuItem
                text="数据接口"
                iconCls="icon-event-window"
              ></MenuItem>
            </SubMenu>

          </MenuItem>
        </SubMenu>
      </MenuItem>
      <MenuItem
        v-if="'device'===selectedNodeType"
        text="新建"
        iconCls="icon-new-add"
      >
        <SubMenu menu-width="60px">
          <MenuItem
            text="文件夹"
            iconCls="icon-folder"
          ></MenuItem>
          <MenuItem
            text="对象"
            iconCls="icon-object"
          >
            <SubMenu menu-width="60px">
              <MenuItem
                text="报警接收者-Printer"
                iconCls="icon-printer"
              ></MenuItem>
              <MenuItem
                text="状态变化-系统"
                iconCls="icon-changeState"
              ></MenuItem>
              <MenuItem
                text="曲线图-实时"
                iconCls="icon-onlineChart"
              ></MenuItem>
              <MenuItem
                text="曲线图-趋势记录"
                iconCls="icon-onlineChartLog"
              ></MenuItem>
              <MenuItem
                text="图形化界面"
                iconCls="icon-graphic"
              ></MenuItem>
              <MenuItem
                text="假期计划表"
                iconCls="icon-holidayPlan"
              ></MenuItem>
              <MenuItem
                text="记事本"
                iconCls="icon-noteBook"
              ></MenuItem>
              <MenuItem
                text="对象传输"
                iconCls="icon-objectTransfer"
              ></MenuItem>
              <MenuItem
                text="时间表"
                iconCls="icon-chartTime"
              ></MenuItem>
              <MenuItem
                text="时间事件-对象"
                iconCls="icon-chartTimeEventObj"
              ></MenuItem>
              <MenuItem
                text="时间事件-列表"
                iconCls="icon-chartTimeEventList"
              ></MenuItem>
              <MenuItem
                text="趋势日志-计算"
                iconCls="icon-trendLogCal"
              ></MenuItem>
              <MenuItem
                text="趋势日志-导出"
                iconCls="icon-trendLogOut"
              ></MenuItem>
              <MenuItem
                text="趋势日志"
                iconCls="icon-trendLog"
              ></MenuItem>
              <MenuItem
                text="值-模拟量"
                iconCls="icon-Analog"
              ></MenuItem>
              <MenuItem
                text="值-二进制"
                iconCls="icon-Binary"
              ></MenuItem>
              <MenuItem
                text="值-多态"
                iconCls="icon-Multistate"
              ></MenuItem>
              <MenuItem
                text="值-字符串"
                iconCls="icon-String"
              ></MenuItem>
              <MenuItem
                text="数值计算"
                iconCls="icon-Count"
              ></MenuItem>
              <MenuItem
                text="报警视窗"
                iconCls="icon-alarm-window"
              ></MenuItem>
              <MenuItem
                text="数据接口"
                iconCls="icon-event-window"
              ></MenuItem>
            </SubMenu>
          </MenuItem>
        </SubMenu>
      </MenuItem>
      <Menu-sep />
      <Menu-sep v-if="!'subDevice'===selectedNodeType" />
      <MenuItem
        v-if="'device'===selectedNodeType"
        text="程序上传"
        iconCls="icon-print"
      ></MenuItem>
      <Menu-sep v-if="!'subDevice'===selectedNodeType" />
      <Menu-sep v-if="'device'===selectedNodeType" />
      <MenuItem
        :disabled="!('root,project,folder,server,logicalGroup,deviceGroup,device,subDevice,onlineChart').includes(selectedNodeType)"
        text="刷新"
        iconCls="icon-reflash"
      >
        <div
          align="right"
          style="font-size: 12px"
        >F5</div>
      </MenuItem>
      <Menu-sep />
      <MenuItem
        :disabled="!('folder').includes(selectedNodeType)"
        text="文件上传"
        iconCls="icon-event-window"
      ></MenuItem>
      <Menu-sep />
      <MenuItem
        :disabled="!('project,folder,server,logicalGroup,deviceGroup,device,subDevice,onlineChart,formulaToValue').includes(selectedNodeType)"
        text="授权"
        iconCls="icon-auth"
      ></MenuItem>
      <Menu-sep />
      <MenuItem
        :disabled="!('project,folder,server,logicalGroup,deviceGroup,onlineChart,formulaToValue').includes(selectedNodeType)"
        text="剪切"
        iconCls="icon-cut"
      ></MenuItem>
      <MenuItem
        :disabled="!('subDevice').includes(selectedNodeType)"
        text="复制"
        iconCls="icon-copy"
      ></MenuItem>
      <MenuItem
        :disabled="!('subDevice').includes(selectedNodeType)"
        text="粘贴"
        iconCls="icon-paste"
      ></MenuItem>
      <Menu-sep />
      <MenuItem
        :disabled="!('root,project,folder,server,logicalGroup,deviceGroup,device,onlineChart,graphic,formulaToValue，subDevice').includes(selectedNodeType)"
        text="修改"
        iconCls="icon-rename"
      ></MenuItem>
      <MenuItem
        :disabled="!('project,folder,server,logicalGroup,deviceGroup,device,onlineChart,graphic,trendLog,trendChart,formulaToValue').includes(selectedNodeType)"
        text="删除"
        iconCls="icon-delete"
      ></MenuItem>
      <Menu-sep />
      <MenuItem
        :disabled="!('root,project,folder,server,logicalGroup,deviceGroup,device,onlineChart,subDevice,formulaToValue').includes(selectedNodeType)"
        text="属性"
        iconCls="icon-property"
      ></MenuItem>
    </Menu>
    <gs-modal
      v-model="visible"
      :before-close="beforeClose"
      class="my-test-class"
      title="删除"
      @close="close"
      @confirm="handleConfirm"
    >
      <span>是否删除？</span>
    </gs-modal>
  </div>
</template>
<script type="text/ecmascript-6">
  import { mapState, mapMutations, mapActions } from 'vuex'
  // import fuzzySearch from '../../../static/fuzzysearch.js'
  import service from '../../service/leftService.js'
  import online from '../../../static/img/new-icno/设备.png'
  import offline from '../../../static/img/new-icno/设备（离线）1.png'
  export default {
    components: {

    },
    data () {
      return {
        copyId:'',
        stickId:'',
        dialogVisible: false,
        values:'', // 计算后的值
        loading: true,
        node:{},
        visible: false, // 控制删除界面的显示
        tree_width: 200, // 左侧树宽度
        grid_width: `${document.documentElement.clientWidth - 205}`, // 右侧列表宽度
        middle_height: `${(document.documentElement.clientHeight - 65) * 0.65}`, // 中间区域高度
        bottom_height: `${(document.documentElement.clientHeight - 65) * 0.35 - 2}`, // 底部区域高度
        grid_title: '文件夹',
        tree_collapsed: false,
        alarm_collapsed: false,
        tree_data: null,
        grid_data: null,
        alarm_data: null,
        event_data: null,
        selectedNodeType: 'root',
        selectedNode: null,
        props: {
          label: 'name'
        },
        deviceStatusList: [],
        timer: null,
        online,
        offline,
        facility:[],
      }
    },
    computed: {
      ...mapState({
        nodeData: 'nodeTree',
        addTreeNode: 'addTreeNode',
        updateTreeNode: 'updateTreeNode',
        delTreeNode: 'delTreeNode',
        loginStatus: 'loginStatus'
        // searchSelect: 'searchSelect'
      })
    },
    watch: {
      loginStatus () {
        if (!this.loginStatus) {
          clearInterval(this.timer)
        }
      },
      '$store.state': {
        handler () {
          if (this.$store.state.isReloadTree === true) {
            this.getAllTree()
            this.donotNeedReload()
            console.log('reload Success!')
          }
        },
        deep: true
      },
      addTreeNode () {
        this.treeAddNode()
      },
      updateTreeNode () {
        this.treeUpdateNode()
      },
      delTreeNode () {
        this.$refs.tree.remove(this.delTreeNode)
      },
      tree_data () {

      },
      nodeData () {
        //includes检测数组中是否包含这些
        if (('root,project,folder,server,logicalGroup,deviceGroup,device,subDevice,onlineChart').includes(this.nodeData.type)) {
          setTimeout(() => {
            this.expandNode(this.nodeData.parentId)
            this.$refs.tree.setCurrentNode(this.nodeData)
          }, 10)
        }
      }
    },
    created () {
      this.loading = false
      //this.addFolderDesginDialog()
      this.getAllTree()
      //this.updateDeviceStatus()
    },
    mounted () {

    },
    destroyed () {
      clearInterval(this.timer)
    },
    methods: {
      ...mapMutations({
        dialogShow: 'DIALOG_SHOW',
        propertiesDialogShow: 'PROPERTIES_DIALOG_SHOW',
        onlineChartDialogShow: 'ONLINECHART_PROPERTIES_DIALOG_SHOW',
        onlineChartTrendShow: 'ONLINECHART_PROPERTIES_TREND_SHOW',
        //图形化展示
        graphiCallyShow: 'GRAPHI_CALLY_SHOW',
        //记事本
        noteBookShow: 'NOTE_BOOK_SHOW',
        //数据接口
        dataInterfaceShow: 'DATA_INTERFACE_SHOW',
        //计算工具
        countBookShow: 'COUNT_BOOK_SHOW',
        //趋势日志
        trendJournalShow: 'TREND_JOURNAL_SHOW',
        //趋势日志数据
        trendLogsShow: 'TREND_LOGS_SHOW',
        trendJournalExpressShow: 'TREND_JOURNAL_EXPRESS_SHOW',
        alarmChartDialogShow: 'ALARMCHART_PROPERTIES_DIALOG_SHOW',
        authorityShow: 'AUTHORITY_SHOW',
        createUserShow: 'CREATE_USER_SHOW',
        createGroupShow: 'CREATE_GROUP_SHOW',
        //属性
        deviceDialogShow: 'DEVICE_DIALOG_SHOW',
        //程序的下载
        orderDialogShow:'ORDER_DIALOG_SHOW',
        deviceListDialogShow: 'DEVICE_LIST_DIALOG_SHOW',
        stateChangeShow: 'CHANGE_OF_STATE_SHOW',
        donotNeedReload: 'DONOT_NEED_RELOAD_TREE',
        alarmControlShow: 'ALARM_CONTROL_SHOW',
        alarmGroupShow: 'GROUP_ALARM_SHOW',
        addFolderDialog: 'FOLDER_SHOW',
        addFolderDesginDialog: 'FOLDER_DESGIN_SHOW',
        timeChartShow: 'TIME_CHART_SHOW', // 时间表
        holidayShow: 'HOLIDAY_SHOW', //假期计划表
        searchDialogShow: 'SEARCH_DIALOG_SHOW',
        objectTransferShow: 'OBJECT_TRANSFER_SHOW',
        timeEventObejctShow: 'TIME_EVENT_OBJECT_SHOW',
        timeEventListShow: 'TIME_EVENT_LIST_SHOW'
      }),
      ...mapActions({
        showPointValueDialog: 'showPointValueDialog'
      }),
      //renderContent节点
      expandNode (id) {
        if (id !== '0') {
          let node = this.$refs.tree.getNode(id)
          node.expanded = true
          if (node.data.parentId !== '0') {
            this.expandNode(node.data.parentId)
          }
        }
      },
      getAllTree () {
        service.getDesignAllTree().then(res => {
          this.tree_data = res[0]
          this.traverseTree(this.tree_data)
          this.tree_data = [this.tree_data]
          this.loading = false
        }).catch(err => {
          this.$Message.error(err.message)
          this.loading = false
        })
      },
      /*renderContent(h, { node, data, store }) {
        return (
          <span class="custom-tree-node">
          <span title={node.label}>{node.label}</span>
          </span>);
      },*/
      getDeviceStatus () {
        service.getDeviceStatus().then(res => {
          this.deviceStatusList = res
          this.deviceStatusList.forEach(res => {
            let node = this.$refs.tree.getNode(res.id)
            if (node != null) {
              if (node.data.attribute.isOnline !== res.isOnline) {
                let temp = node.data.name
                node.data.name = ''
                if (res.isOnline) {
                  node.data.icon = this.online
                  node.data.attribute.isOnline = res.isOnline
                  node.data.name = temp
                } else {
                  node.data.icon = this.offline
                  node.data.attribute.isOnline = res.isOnline
                  node.data.name = temp
                }
              }
            }
          })
        }).catch(err => {
          this.$Message.error(err.message)
          clearInterval(this.timer)
        })
      },
      updateDeviceStatus () {
        clearInterval(this.timer)
        this.getDeviceStatus()
        this.timer = setInterval(() => {
          this.getDeviceStatus()
        }, 60000)
      },
      traverseNode (node) {
        switch (node.type) {
          case 'project':
            node['icon'] = '../../../static/img/new-icno/项目1.png'
            break
          case 'folder':
            // 文件夹
            node['icon'] = '../../../static/img/aim-icon/逻辑 (2).png'
            break
          case 'deviceGroup':
            node['icon'] = '../../../static/img/aim-icon/设备组.png'
            break
          case 'device':
            // node['icon'] = '../../../static/img/new-icno/设备.png'
            if (node.attribute.isOnline) {
              node['icon'] = '../../../static/img/aim-icon/设备(在线).png'
              console.info(node.name+"-----是否在线-----"+node.attribute.isOnline)
            } else {
              node['icon'] = '../../../static/img/aim-icon/设备(离线).png'
              console.info(node.name+"-----是否在线-----"+node.attribute.isOnline)
            }
            break
          case 'onlineChart':
            //node['icon'] = '../../../static/img/new-icno/实时动态图.png'
            node['icon'] = '../../../static/img/aim-icon/曲线图.png'
            break
          case 'trendChart':
            //node['icon'] = '../../../static/img/new-icno/实时动态图.png'
            node['icon'] = '../../../static/img/aim-icon/曲线图.png'
            break
          // 加载图形化界面图标
          case 'graphic':
            node['icon'] = '../../../static/img/aim-icon/图形化界面.png'
            break
          // 趋势日志
          case 'trendLog':
            node['icon'] = '../../../static/img/aim-icon/趋势日志.png'
            break
          case 'subDevice':
            node['icon'] = '../../../static/img/aim-icon/子设备.png'
            break
          case 'server':
            node['icon'] = '../../../static/img/new-icno/项目tool1.png'
            break
          case 'root':
            node['icon'] = '../../../static/img/new-icno/设计tool.png'
            break
          case 'logicalGroup':
            node['icon'] = '../../../static/img/new-icno/场景 (3).png'
            break
          case 'formulaToValue':
            node['icon'] = '../../../static/img/aim-icon/计算器.png'
            break
          default:
            break
        }
        return node
      },
      traverseTree (node) {
        if (!node) {
          return
        }

        let stack = []
        stack.push(node)
        let tmpNode
        while (stack.length > 0) {
          tmpNode = stack.pop()
          this.traverseNode(tmpNode)
          if (tmpNode.children && tmpNode.children.length > 0) {
            let i = tmpNode.children.length - 1
            for (i = tmpNode.children.length - 1; i >= 0; i--) {
              stack.push(tmpNode.children[i])
            }
          }
        }
      },
      //Tree点击鼠标左键触发
      tree_left_click (node) {
        if(node.type ===  "formulaToValue") {
          service.formulaToValue(node.id).then(res =>{
            _this.values = res.value
            _this.dialogVisible = true
          }).catch(err=>{
            console.log(err)
          })
        }
        if(this.$refs.tree.store.nodesMap[node.id].expanded){ // 判断树的节点是否展开tree已经展开  false关闭
          this.$refs.tree.store.nodesMap[node.id].expanded = false;
          node.unfold = false;
        }else {
           //  节点展开
          this.$refs.tree.store.nodesMap[node.id].expanded = true;
          node.unfold = true;
          if(node.type === "device"){
            //this.loading = true
            let _this = this
            let nodeId = node.id
            service.getChildrenNode(nodeId).then(res =>{
              _this.$store.state.addTreeNode = res
              setTimeout(function () {
                _this.loading = false
              },1500)
            }).catch(err => {
              console.info(err)
              setTimeout(function () {
                _this.loading = false
              },1000)
            })
          }
        }
        let _this = this
        // 改变vuex中属性的值
        this.$store.state.leftClickNode = new Date().getTime()
        this.$store.state.toolTreeNode = node
        this.selectedNode = node
        this.selectedNodeType = node.type
      },
      //Tree点击鼠标右键出发
      tree_right_click (event, node, value, element) {
        //拿到对象的所有属性
        this.node = node
        this.$store.state.objectInfo = node
        this.selectedNodeType = node.type
        this.$refs.tree.setCurrentNode(node)
        this.selectedNode = node
        this.$refs.context_menu.showContextMenu(event.pageX, event.pageY)
        //模板添加的操作把必要的值存入localStorage中
        if(node.type === 'device'){
          let deviceId = node.id
          let subDeviceId = ''
          for(let i = 0 ; i<node.children.length ; i++){
            if(node.children[i].type === 'subDevice'){
              subDeviceId += node.children[i].id+','
            }
          }
          localStorage.setItem("deviceId"+node.id,deviceId)
          localStorage.setItem("subDeviceId"+node.id,subDeviceId)
        }
      },
      tree_selection_change (node) {
        this.selectedNode = node
        this.selectedNodeType = node.type
      },
      tree_menuItemClick (event) {
        switch (event) {
          case '展开':
            this.openTree()
            break
          case '折叠':
            this.fold()
            break
          case '删除':
            this.visible = true
            break
          case '项目组':
            this.addFolder('project')
            break
          case '逻辑组':
            this.addFolder('folder')
            break
          case '文件夹':
            this.addFolder('folder')
            break
          case '项目':
            this.addFolder('server')
            break
          case '场景':
            this.addFolder('logicalGroup')
            break
          case 'AIM':
            this.addFolder('deviceGroup')
            break
          case 'ICU':
            this.deviceListDialogShow()
            break
          case '报警控制':
            this.alarmControl()
            break
          case '时间表':
            this.timeChart()
            break
          case '假期计划表':
            this.holidayChart()
            break
          case '用户':
            this.user()
            break
          case '用户组':
            this.userGroup()
            break
          case '用户组-报警':
            this.alarmGroup()
            break
          case '状态变化-系统':
            this.changeOfState()
            break
          case '曲线图-实时':
            this.turnToChart()
            break
          case '曲线图-趋势记录':
            this.turnToChartTrend()
            break
          case '记事本':
            this.noteBook()
            break
          case '数值计算':
            this.countBook()
            break
          case '趋势日志':
            this.trendJournal()
            break
          case '趋势日志-导出':
            this.trendJournalExpres()
            break
          case '报警接收者-Printer':
            this.turnToAlarmChart()
            break
          case '图形化界面':
            this.graphiCally()
            break
          case '值-模拟量':
            this.showPointValueDialog({
              type: 'Analog',
              isEdit: false
            })
            break
          case '值-二进制':
            this.showPointValueDialog({
              type: 'Binary',
              isEdit: false
            })
            break
          case '值-多态':
            this.showPointValueDialog({
              type: 'Multistate',
              isEdit: false
            })
            break
          case '值-字符串':
            this.showPointValueDialog({
              type: 'String',
              isEdit: false
            })
            break
          case '授权':
            this.authorityShow()
            break
          case '程序上传':
            this.orderDownShow()
            break
          case '属性':
            this.properties()
            break
          case '修改':
            this.properties()
            break
          case '搜索':
            this.searchDialogShow()
            break
          case '对象传输':
            this.objectTransferShow()
            break
          case '时间事件-对象':
            this.timeEventObejctShow()
            break
          case '时间事件-列表':
            this.timeEventListShow()
            break
          case '刷新':
            this.renovate()
            break
          case '检查设备':
            this.isOnline()
            break
          case '复制':
            this.copyData()
            break
          case '粘贴':
            this.stickData()
            break
          case '数据接口':
            this.dataInterfaceShow()
            break
          default:
            break
        }
      },
      kong () {
      },
      addFolder (type) { // 添加路径
        this.$store.state.type = type
        this.addFolderDesginDialog()
      },
      treeAddNode () {
        let oldChildNodes = this.$refs.tree.getNode(this.selectedNode.id).childNodes
        let expandedNodes = []
        this.addExpandedNodes(oldChildNodes, expandedNodes)
        if(this.selectedNode.type === "device"){
          service.getChildrenNode(this.selectedNode.id).then(res => {
            let updateNode = res[0]
            this.traverseTree(updateNode)
            this.$refs.tree.updateKeyChildren(this.selectedNode.id, updateNode.children)
            expandedNodes.forEach(e => {
              this.$refs.tree.store.nodesMap[e.data.id].expanded = true
            })
            this.$refs.tree.store.nodesMap[this.selectedNode.id].expanded = true
            setTimeout(() => {
              if (Array.isArray(this.addTreeNode)) {
                this.$refs.tree.setCurrentNode(this.addTreeNode[0])
              } else {
                this.$refs.tree.setCurrentNode(this.addTreeNode)
              }
            }, 20)
          }).catch(err => {
            console.log(err)
            // this.$Message.error(err.message)
          })
        }else{
          service.getTree('', this.selectedNode.id).then(res => {
            let updateNode = res[0]
            this.traverseTree(updateNode)
            this.$refs.tree.updateKeyChildren(this.selectedNode.id, updateNode.children)
            expandedNodes.forEach(e => {
              this.$refs.tree.store.nodesMap[e.data.id].expanded = true
            })
            this.$refs.tree.store.nodesMap[this.selectedNode.id].expanded = true
            setTimeout(() => {
              if (Array.isArray(this.addTreeNode)) {
                this.$refs.tree.setCurrentNode(this.addTreeNode[0])
              } else {
                this.$refs.tree.setCurrentNode(this.addTreeNode)
              }
            }, 20)
          }).catch(err => {
            console.log(err)
            // this.$Message.error(err.message)
          })
        }


      },
      addExpandedNodes (childNodes, expandedNodes) {
        if (childNodes.length > 0) {
          childNodes.forEach(res => {
            this.addExpandedNodes(res.childNodes, expandedNodes)
            if (res.expanded) {
              expandedNodes.push(res)
            }
          })
        }
      },
      // treeAddNode () {
      //   let newChild = null
      //   if (Array.isArray(this.addTreeNode)) {
      //     let array = this.addTreeNode
      //     array.forEach(e => {
      //       e = this.traverseTree(e)
      //     })
      //     newChild = array
      //   } else {
      //     newChild = this.traverseNode(this.addTreeNode)
      //   }
      //   if (newChild.length) {
      //     newChild.forEach(res => {
      //       this.$refs.tree.append(res, this.selectedNode)
      //     })
      //   } else {
      //     this.$refs.tree.append(newChild, this.selectedNode)
      //   }
      //   this.$refs.tree.store.nodesMap[this.selectedNode.id].expanded = true
      //   this.$refs.tree.setCurrentNode(newChild)
      // },
      treeUpdateNode () {
        let node = this.$refs.tree.getNode(this.updateTreeNode.id)
        if (this.updateTreeNode.type === 'onlineChart') {
          node.data = this.updateTreeNode
          node.data.icon = '../../../static/img/aim-icon/曲线图.png'
        } else {
          node.data.name = this.updateTreeNode.name
          node.data.fullName = this.updateTreeNode.fullName
          node.data.description = this.updateTreeNode.description
        }
      },
      treeDeleteNode () { // 删除节点
        service.removePoint(this.selectedNode.id).then(res => {
          this.$Message.success('删除成功')
          this.$refs.tree.remove(this.selectedNode)
          // this.$store.state.nodeTree = {}
          this.$router.push({name: 'Home'})
        }).catch(err => {
          this.$Message.error(err.message)
        })
      },
      orderDownShow(){//程序的下载
        //弹出框的展示
        this.orderDialogShow()
      },
      // 刷新操作
      renovate(){
        let _this = this
        setTimeout(function () {
          _this.loading = false
        },2000)
        this.loading = true
        this.getDeviceStatus()
      },
      properties () { // 属性
        if (this.selectedNodeType === 'project' || this.selectedNodeType === 'server' || this.selectedNodeType === 'folder' || this.selectedNodeType === 'logicalGroup' || this.selectedNodeType === 'deviceGroup') {
          this.propertiesDialogShow()
        }
        if (this.selectedNodeType === 'onlineChart') {
          this.onlineChartDialogShow()
        }
        if (this.selectedNodeType === 'alarmReceiverEmail') {
          this.alarmChartDialogShow()
        }
        if (this.selectedNodeType === 'device') {
          // 弹出框的展示
          this.deviceDialogShow()
        }
        if (this.selectedNodeType === 'subDevice') {
          // 弹出框的展示
          this.deviceDialogShow()
          // this.$Message.error('子设备无属性设置')
        }
        if (this.selectedNodeType === 'graphic') {
          this.graphiCallyShow()
        }
        this.hideRightMenu()
      },
      //曲线图-实时
      turnToChart () {
        this.onlineChartDialogShow()
        this.hideRightMenu()
      },
      //曲线图-趋势记录
      turnToChartTrend () {
        this.onlineChartTrendShow()
        this.hideRightMenu()
      },
      //图形化界面
      graphiCally(){
        this.graphiCallyShow()
        this.hideRightMenu()
      },
      //记事本
      noteBook(){
        this.noteBookShow()
        this.hideRightMenu()
      },
      //计算工具
      countBook(){
        this.countBookShow()
        this.hideRightMenu()
      },
      //趋势日志
      trendJournal(){
        this.trendJournalShow()
        this.hideRightMenu()
      },
      //趋势日志导出
      trendJournalExpres(){
        this.trendJournalExpressShow()
        this.hideRightMenu()
      },
      turnToAlarmChart () {
        this.alarmChartDialogShow()
        this.hideRightMenu()
      },
      user () {
        this.createUserShow()
        this.hideRightMenu()
      },
      userGroup () {
        this.createGroupShow()
        this.hideRightMenu()
      },
      addNewDevice () {
        // this.deviceDialogShow()
        this.deviceListDialogShow()
        this.hideRightMenu()
      },
      changeOfState () {
        this.stateChangeShow()
        this.hideRightMenu()
      },
      alarmControl () {
        this.alarmControlShow()
        this.hideRightMenu()
      },
      alarmGroup () {
        this.alarmGroupShow()
        this.hideRightMenu()
      },
      close () {
        this.visible = false
      },
      beforeClose () {
        this.visible = false
      },
      handleConfirm () {
        this.treeDeleteNode()
        this.visible = false
      },
      hideRightMenu () {
        //传输正确的数据(已标签的形式)
        let rMenu = $('#rMenu')
        let secondMenu = $('.second-menu')
        let thirdMenu = $('.third-menu')
        rMenu.css({'visibility': 'hidden'})
        secondMenu.css({'visibility': 'hidden'})
        thirdMenu.css({'visibility': 'hidden'})
      },
      timeChart () { // 时间表
        this.timeChartShow()
        this.hideRightMenu()
      },
      holidayChart () {  // 假期计划表
        this.holidayShow()
        this.hideRightMenu()
      },
      // 展开
      openTree(){
        let _this = this
        this.$refs.tree.store.nodesMap[this.node.id].expanded = true;
        this.node.unfold = true;
        service.getTree("",this.node.id).then(res =>{
          console.info("接收到的数据")
          console.info(res)
          _this.$store.state.addTreeNode = res
        }).catch(err => {
          console.info(err)
        })
      },
      // 折叠
      fold(){
        this.$refs.tree.store.nodesMap[this.node.id].expanded = false;
        this.node.unfold = false;
      },
      handleClose(){
        this.dialogVisible = false
      },
      // 检查设备是否在线
      isOnline() {
        service.isOnline(this.nodeData.id).then(res => {
          this.$Message.success("设备检查成功")
        }).catch(err => {
          console.log(err)
        })
      },
      // 复制
      copyData(){
        this.copyId = this.nodeData.id
        if(this.copyId === ""){
          this.$Message.error("复制失败")
        }else{
          this.$Message.success("复制成功")
        }
      },
      // 粘贴
      stickData(){
        this.stickId = this.nodeData.id
        service.copyPaste(this.copyId,this.stickId).then(res => {
          this.$Message.success("粘贴成功")
        }).catch(err => {
          this.$Message.error("粘贴失败")
        })
      }
    }
  }
</script>

<style scoped>
  .design-tree{
    height: 100%;
    background-color: #FFFFFF;
  }
</style>



// WEBPACK FOOTER //
// src/pages/designtoolpages/TheAside.vue